// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardFilledSvg from "@ant-design/icons-svg/es/asn/DashboardFilled";
import AntdIcon from '../components/AntdIcon';

var DashboardFilled = function DashboardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardFilledSvg
  }));
};

DashboardFilled.displayName = 'DashboardFilled';
export default React.forwardRef(DashboardFilled);